/** Rutas FastAPI definidas como GET "/" que exigen barra final (evita 307 → http en proxy). */
const COLLECTION_PATHS = /^\/(tratamientos|pacientes|atenciones|gastos|temperaturas)(\/|\?|$)/

/** Añade barra final antes del query string en listados de colección. */
export function ensureCollectionTrailingSlash(path: string): string {
  const qIndex = path.indexOf('?')
  const pathname = qIndex >= 0 ? path.slice(0, qIndex) : path
  const query = qIndex >= 0 ? path.slice(qIndex) : ''

  if (pathname.endsWith('/') || /\/\d+$/.test(pathname)) {
    return path
  }

  if (COLLECTION_PATHS.test(pathname)) {
    return `${pathname}/${query}`
  }

  return path
}

/** Evita rutas duplicadas tipo /api/v1/api/v1/... al combinar baseURL + path */
export function normalizeApiPath(path: string, basePath = '/api/v1'): string {
  let normalized = path

  if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
    try {
      const parsed = new URL(normalized)
      normalized = parsed.pathname + (parsed.search || '')
    } catch {
      const match = normalized.match(/\/api\/v1(\/.*)?(\?.*)?$/)
      if (match) {
        normalized = `/api/v1${match[1] || ''}${match[2] || ''}`
      }
    }
  }

  normalized = normalized.startsWith('/') ? normalized : `/${normalized}`

  const base = basePath.replace(/\/+$/, '')
  // Quitar prefijos /api/v1 repetidos (p. ej. /api/v1/api/v1/configuracion/me)
  while (normalized === base || normalized.startsWith(`${base}/`)) {
    normalized = normalized.slice(base.length) || '/'
  }

  normalized = normalized.startsWith('/') ? normalized : `/${normalized}`
  return ensureCollectionTrailingSlash(normalized)
}
